export const ArrowBottomIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
    <path fillRule="evenodd" clipRule="evenodd"
          d="M12.0577 5.96967C11.7648 5.67678 11.2899 5.67678 10.997 5.96967L8.52734 8.43934L6.05767 5.96967C5.76478 5.67678 5.28991 5.67678 4.99701 5.96967C4.70412 6.26256 4.70412 6.73744 4.99701 7.03033L7.99701 10.0303C8.28991 10.3232 8.76478 10.3232 9.05767 10.0303L12.0577 7.03033C12.3506 6.73744 12.3506 6.26256 12.0577 5.96967Z"
          fill="#A7ADBA"/>
  </svg>
)
